import createSagaMiddleware from 'redux-saga';
import {configureStore} from '@reduxjs/toolkit';
import rootReducer from './reducers';
import rootSaga from './sagas';

export function createAppStore() {
    const saga = createSagaMiddleware();
    const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(saga),
    });
    if (typeof document !== 'undefined') saga.run(rootSaga);
    return store;
}
